import { z } from "zod";
import { InductionLocaleSchema } from "./induction-locale";
import { EventTimeSourceSchema } from "./event-time-provenance";

export const SiteInductionAcknowledgementSchema = z
  .object({
    projectId: z.string(),
    siteFieldsHash: z.string(),
    acknowledgedAt: z.string().datetime(),
    acknowledgedReceivedAt: z.string().datetime().nullable().optional(),
    acknowledgedTimeSource: EventTimeSourceSchema.nullable().optional(),
    // Language the worker was shown at acknowledgement time (issue #991).
    // Absent/null on legacy rows and English acknowledgements.
    locale: InductionLocaleSchema.nullish(),
  })
  .strict();

export type SiteInductionAcknowledgement = z.infer<
  typeof SiteInductionAcknowledgementSchema
>;
